import { types as t, getParent } from 'mobx-state-tree';
import PropertyItem from './PropertyItem';

export default t.model("Variant", {
	
	Sku: t.identifier,
	
	VariantSku: t.string,
	
	Name: t.string,
	

	Guid: t.string,

    Properties: t.optional(PropertyItem, {}),
	
	
}).views(self => ({
    get Product() {
        return getParent(self, 2);
    },
    get InStock() {
        return self.InStock || self.Product.Stock.filter(x => x.Sku === self.VariantSku).reduce((total, item) => total + item.Quantity, 0) > 0;
    },

    get InStockPrimary() {
        return self.Product.Stock.filter(x => x.Sku === self.VariantSku && x.StockAlias==="Primary").reduce((total, item) => total + item.Quantity, 0) > 0;
    },

    get InStockSecondary() {
        return self.Product.Stock.filter(x => x.Sku === self.VariantSku && x.StockAlias==="Secondary").reduce((total, item) => total + item.Quantity, 0) > 0;
    }

})).actions(self => ({

}));